import { DataGrid } from '@nokia-csf-uxr/ccfk';
import { useState, useRef } from 'react';
import { AllCommunityModules } from '@ag-grid-community/all-modules';

/**
 * Link performance data grid
 * @param {*} props
 * props.data : get link information (it's an array for a single band, else an object)
 * props.band : define the band to display (by default it's the first band)
 * @returns 
 */
const LinkPerformance = (props) => {

  const [rowData, setRowData] = useState([]);

  const gridApi = useRef(null);

  const valuesUpdated = useRef(false);

  const isDualBand = useRef(!Array.isArray(props.data));

  if(valuesUpdated.current) {
    valuesUpdated.current = false;
  } else {
    setRowData(props.data)
    valuesUpdated.current = true;
  }

  return (

    <DataGrid
      modules={AllCommunityModules}
      wrapperProps={{
        style: {
          height: '100%',
          minHeight: '400px',
          width: '100%'
        }
      }}
      rowData={rowData}
      suppressContextMenu
      suppressColumnMoveAnimation={true}
      animateRows={false}
      defaultColDef={{
        menuTabs: ['filterMenuTab']
      }}
      columnDefs={ singleBandColumnsDefs() }
      onGridReady={(params) => {
        gridApi.current = params.api;
      }}
      onFirstDataRendered = {(params) => {
        params.api.sizeColumnsToFit();
      }}
    />
  );
};

export default LinkPerformance;

/**
 * Give a format X mins X secs with total outage
 * @param {*} totalOutage 
 * @returns X mins X secs
 */
function calculateOutagePerYear(totalOutage){
  var days = 365.2425; // gregorian year
  var secondsyear = days * 24 * 60 * 60;
  let sum = 0;
  sum = secondsyear * totalOutage / 100;
  var totalSecs =  parseInt(sum.toString());
  let secs = totalSecs % 60;
  let mins = parseInt((totalSecs / 60).toString());
  if(mins >= 525600) { // 525600 minutes = 1 year
    return "OUT of RANGE"
  }
  return mins + 'min ' + secs + 'sec';
}

/**
 * Column definitions
 */

const singleBandColumnsDefs = () => [
  {
    headerName: 'Modulation',
    field: 'modulation',
    width: 100,
    cellStyle: {fontSize: '11px'}
  },
  {
    headerName: 'Capacity [Mbps]',
    field: 'capacity',
    width: 125,
    cellStyle: {fontSize: '11px'}
  },
  {
    headerName: 'Total Availability [%]',
    field: 'availability',
    width: 150,
    cellStyle: {fontSize: '11px'},
    cellRenderer: params => {
      // put the value in bold
      return params.value < 0 || params.value > 100 ? "OUT of RANGE" : params.value;
    }
  },
  {
    headerName: 'Outage/year',
    field: 'outage',
    width: 125,
    cellStyle: {fontSize: '11px'},
    cellRenderer: params => {
      // put the value in bold
      return calculateOutagePerYear(params.value);
    }
  },
  {
    headerName: 'Fade Margin [dB]',
    field: 'fadeMargin',
    width: 125,
    cellStyle: {fontSize: '11px'}
  },
  {
    headerName: 'TX Power [dBm]', 
    field: 'txPower',
    width: 125,
    cellStyle: {fontSize: '11px'}
  },
  { 
    headerName: 'RX Level [dBm]', 
    field: 'rxLevel',
    width: 125,
    cellStyle: {fontSize: '11px'}
  }
];